module.exports = __webpack_public_path__ + "static/img/alesong_join_us.448d3c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alesong_join_us.jpg
// module id = 287
// module chunks = 1